// extracted by mini-css-extract-plugin
module.exports = {"f166jgra":"f166jgra"};